// extracted by mini-css-extract-plugin
export default {"vehiclesCharacteristicsWrapper":"vehicles-characteristics_vehiclesCharacteristicsWrapper__4CSBh","characteristicWrapper":"vehicles-characteristics_characteristicWrapper__3XK7Q"};